import qs from 'qs';
import axios from 'axios'
import { Message } from 'element-ui';

// AI平台API基础地址（使用相对路径，配合vue.config.js中的代理）
const baseUrl = 'https://api.jasdm.cn/ai-platform';

// 创建新的axios实例
const aiAxiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 10000
});

// 转换请求数据
aiAxiosInstance.defaults.transformRequest = [function (data, headers) {
  // 如果是FormData类型，直接返回
  if (data instanceof FormData) {
    return data;
  }
  // 检查请求头是否为application/json，如果是则转换为JSON字符串
  if (headers && headers['Content-Type'] === 'application/json') {
    return JSON.stringify(data);
  }
  // 其他情况使用默认处理
  return qs.stringify(data)
}];

/*
 * 增加请求拦截器
 */
aiAxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').user_token) : "";
  
  if (token) {
    config.headers['paper_token'] = token;
  }
  
  // if (!token) {
  //   window.location.href = '/login';
  //   return Promise.reject(new Error('未登录'));
  // }
  
  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

/*
 * 增加响应拦截器
 */
aiAxiosInstance.interceptors.response.use((response) => {
  console.log(response, '----51-----', response.data.code)

  if (response.data.code === 401) {
    Message.error('未登录，请重新登录');
    setTimeout(() => {
      window.location.href = '/login';
    }, 2000);
    return Promise.reject(response);
  }
  
  if (response.data.code === 600) {
    Message.error('权限不足，请开通会员');
    setTimeout(() => {
      window.location.href = '/vip';
    }, 2000);
    return Promise.reject(response);
  }

  if (response.data.code === 200) {
    return response
  } else {
    const errorMsg = response.data.msg || '请求失败'
    Message.error(errorMsg)
    return Promise.reject({
      status: response.data.code,
      msg: errorMsg
    })
  }
}, (error) => {
  const errorResult = checkStatus(error)

  if (errorResult.msg) {
    Message.error(errorResult.msg)
  }

  return Promise.reject(errorResult)
})

/**
 * 状态码校验
 * @param response
 * @return {*}
 */
function checkStatus(response) {
  // 有响应时校验状态
  if (response) {

    console.log(response, '----67-----')

    // -10 自己定义，连接错误的status
    const status = response.status || -10
    if (status === 200 || status === 304 || status === 400) {
      return response.data
    } else {
      let errorInfo = response.data.msg || '连接错误'
      return {
        status,
        msg: errorInfo
      }
    }
  }
  // 异常状态下，返回错误信息
  return {
    status: -404,
    msg: '网络异常'
  }
}

/**
 * 返回axios方法
 * @param url
 * @param method
 * @param timeout
 * @param data
 * @param params
 * @param headers
 * @param dataType
 * @returns {AxiosPromise}
 */
export default function (url, {
  // 默认请求方式post
  method = 'post',
  // 超时
  timeout = 10000,
  // 请求体
  data = {},
  // 查询参数（用于GET请求）
  params = {},
  // 请求头
  headers = {},
  // 文件类型
  dataType = 'json'
}) {

  const config = {
    method: method,
    timeout: timeout,
    url: url,
    data: data,
    params: params,
    headers: headers
  }
  return aiAxiosInstance(config)
}